<template>
  <div class="my-10">
    <FormSelect
      v-model="activeLanguage"
      :options="languages"
      value-key="value"
      label-key="name"
      placeholder="Language"
      @on-select="changeLocale"
      selected-option-styles="bg-white md:!px-3 px-1 !border !border-[#F5F6FA] sm:min-w-[102px] text-sm"
    >
      <template #chevron>
        <img
          src="@/assets/svg/arrow-down.svg"
          alt="Flag"
          class="object-cover md:block hidden duration-300 rounded-sm"
        />
      </template>
      <template #option="{ option }">
        <div class="flex items-center gap-2">
          <img
            :src="`/svg/${option.value}.svg`"
            class="w-5 h-5 object-cover rounded-sm"
            alt="flag"
          />
          <span>{{ option.name }}</span>
        </div>
      </template>
      <template #selectedOption="{ value }">
        <div class="flex items-center gap-2">
          <img
            :src="`/svg/${value}.svg`"
            class="w-5 h-5 object-cover rounded-sm"
            alt="flag"
          />
          <span>{{
            languages.find((lang) => lang.value === value)?.name
          }}</span>
        </div>
      </template>
    </FormSelect>
  </div>
</template>

<script setup lang="ts">
import { FormSelect } from "@/components/Base";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

const languages = ref([
  { name: "Русский", value: "ru" },
  { name: "O'zbek", value: "uz" },
]);

const activeLanguage = ref(locale.value);

const changeLocale = (option: { value: string }) => {
  locale.value = option.value;
  activeLanguage.value = option.value;
  localStorage.setItem("locale", option.value);
};

watch(locale, (newLocale) => {
  activeLanguage.value = newLocale;
  window.location.reload();
});
</script>
